'use strict';

angular.module('user')
    .component('changePasswordError', {
        templateUrl: 'html/components/user/change-password/error.html',
    });
